"use strict";

var _require = require("./constants"),
    DEFAULT_OPTIONS = _require.DEFAULT_OPTIONS,
    imageClass = _require.imageClass,
    imageBackgroundClass = _require.imageBackgroundClass,
    imageWrapperClass = _require.imageWrapperClass;

exports.onRouteUpdate = function (apiCallbackContext, pluginOptions) {
  var options = Object.assign({}, DEFAULT_OPTIONS, pluginOptions);
  var imageWrappers = document.querySelectorAll("." + imageWrapperClass); // https://css-tricks.com/snippets/javascript/loop-queryselectorall-matches/
  // for cross-browser looping through NodeList without polyfills

  var _loop = function _loop(i) {
    var imageWrapper = imageWrappers[i];
    var backgroundElement = imageWrapper.querySelector("." + imageBackgroundClass);
    var imageElement = imageWrapper.querySelector("." + imageClass);

    var onImageComplete = function onImageComplete() {
      backgroundElement.style.opacity = 0;
      imageElement.style.opacity = 1;
      imageElement.removeEventListener("load", onImageComplete);
      imageElement.removeEventListener("error", onImageComplete);
    };

    imageElement.addEventListener("load", onImageComplete);
    imageElement.addEventListener("error", onImageComplete);

    if (imageElement.complete) {
      onImageComplete();
    }
  };

  for (var i = 0; i < imageWrappers.length; i++) {
    _loop(i);
  }
};